/**
 * Shipper actions
 */

const actions = {};

export default actions;